import { Model } from '@vuex-orm/core'

export default class News extends Model {
  static entity = 'news'
  static primaryKey = '_id'

  static fields () {
    return {
      _id: this.attr(null),
      title: this.string(''),
      content: this.string(''),
      type: this.attr(''),
      published: this.boolean(false),
      createdBy: this.attr(null),
      createdAt: this.attr(''),
      image: this.attr(''),
      teams: this.attr('')
    }
  }
}

export class NewsRecord extends News {
  static entity = 'administration:news'
  static fields () {
    return {
      ...super.fields()
    }
  }

  static defaults () {
    return {
      type: 'team',
      published: false
    }
  }
}
